



















































import Vue from 'vue';
import { BButton, BFormInput } from 'bootstrap-vue';

import { mapActions, mapGetters } from '@/state/modules/survey_builder';
import { QuestionOption } from '@/state/modules/survey_builder/state';

export default Vue.extend({
  name: 'QuestionEditOption',
  components: {
    BButton,
    BFormInput,
  },
  props: {
    option: {
      type: Object as () => QuestionOption,
      required: true,
    },
    questionType: {
      type: String,
      required: true,
    },
    hasWeight: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isOptionTitleValid: 'isEditQuestionOptionTitleValid',
      isOptionMultiplierValid: 'isEditQuestionOptionMultiplierValid',
    }),

    isTitleValid(): boolean {
      return this.isOptionTitleValid(this.option);
    },
    isMultiplierValid(): boolean {
      return this.isOptionMultiplierValid(this.option);
    },
  },
  methods: {
    ...mapActions({
      setOptionTitle: 'setQuestionOptionTitle',
      setOptionMultiplier: 'setQuestionOptionMultiplier',
      removeOption: 'removeQuestionOption',
      addOptionSubquestion: 'addQuestionOptionSubquestion',
    }),

    setTitle(title: string) {
      this.setOptionTitle({
        optionId: this.option.id,
        title,
      });
    },
    setMultiplier(multiplier: string) {
      this.setOptionMultiplier({
        optionId: this.option.id,
        multiplier: parseFloat(multiplier),
      });
    },
    remove() {
      this.removeOption(this.option.id);
    },
    addSubquestion() {
      this.addOptionSubquestion(this.option.id);
    },
  },
});
